import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ArticlePlace } from 'app/shared/models/class/offer/offer';

@Injectable({
  providedIn: 'root'
})
export class ArticlePlaceService {

  private url = environment.apiUrl + '/ArticlePlace';

  constructor(private http: HttpClient) {}

  getByArticle(articleKey: number): Observable<ArticlePlace[]> {
    return this.http.get<ArticlePlace[]>(`${this.url}/Article/${articleKey}`);
  }

  post(articleKey: number, articlePlaces: ArticlePlace[]): Observable<void> {
    return this.http.post<void>(`${this.url}/article`, { articleKey, articlePlaces });
  }

  delete(articlePlaceKey: number) {
    return this.http.delete(`${this.url}/${articlePlaceKey}`);
  }

}
